import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Text } from '@atomic';
import { COLOR_FONT_POINT, COLOR_RED } from '@assets/color';

const NoticeWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 43px;
`;
const LinkWrapper = styled(Link)`
  margin-left: 4px;
  text-decoration: none;
`;

const type = {
  signUp: {
    text: '아이디가 있나요?',
    linkText: '로그인',
    linkUrl: '/login',
    error: '이메일 중복!! 확인해주세요!',
  },
  login: {
    text: '계정이 없으시다면?',
    linkText: '회원가입',
    linkUrl: '/signup',
    error: '이메일과 비밀번호를 확인해주세요!',
  },
};

const errorStyle = {
  marginTop: '16px',
  textAlign: 'center',
};

function Notice({ auth, isCheck, ...props }) {
  const { text, linkText, linkUrl, error } = type[auth];

  return (
    <div {...props}>
      <NoticeWrapper>
        <Text textSize={18}>{text}</Text>
        <LinkWrapper to={linkUrl}>
          <Text textSize={18} textColor={COLOR_FONT_POINT}>
            {linkText}
          </Text>
        </LinkWrapper>
      </NoticeWrapper>
      <Text block textSize={16} textColor={COLOR_RED} style={errorStyle}>
        {isCheck && error}
      </Text>
    </div>
  );
}

Notice.propTypes = {
  auth: PropTypes.oneOfType(['signUp', 'login']),
  isCheck: PropTypes.bool.isRequired,
};

export default Notice;
